import type { CanvasEntity, TaskData } from '../entityTypes';
import type { EntityRectMap } from '../types';
import type { GlobalTasksById } from '../../stores/types';

/**
 * Build an EntityRectMap from raw entities.
 * Maps entity ID -> { x, y, width, height } for all entities with own rects.
 * Task entities are keyed by taskId (validated against tasksById).
 */
export function buildEntityRectMap(
  rawEntities: CanvasEntity[],
  tasksById: GlobalTasksById,
): EntityRectMap {
  const map: EntityRectMap = new Map();
  for (const e of rawEntities) {
    switch (e.kind) {
      case 'task': {
        const td = e.data as unknown as TaskData;
        if (tasksById[td.taskId]) {
          map.set(td.taskId, { x: e.x, y: e.y, width: e.width, height: e.height });
        }
        break;
      }
      case 'waypoint':
      case 'textblock':
      case 'textlabel':
      case 'sprite':
      case 'image':
      case 'blocknode':
      case 'shape':
        map.set(e.id, { x: e.x, y: e.y, width: e.width, height: e.height });
        break;
    }
  }
  return map;
}
